<template>
  <div
    class="flex gap-8"
    :class="[animatedElementRootClass, animatedElementTransitionClasses]"
  >
    <AppLabel
      v-for="label in store.labels"
      :key="label.Color + label.Text"
      :color="label.Color"
      :text="label.Text"
    />
  </div>
</template>

<script lang="ts" setup>
import { useMaxHeightAnimator } from '~/composables/general/useMaxHeightAnimator';

const store = useMyProductPageStore();

const {
  setElementHeightCallback,
  animatedElementTransitionClasses,
  animatedElementRootClass,
} = useMaxHeightAnimator({ listenToResize: true });

const amountOfLabels = computed(() => store.labels?.length ?? 0);

watch(amountOfLabels, () => {
  setElementHeightCallback();
});
</script>

<style lang="scss" scoped></style>
